import React from "react";
import { Container, Stack } from "react-bootstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the styles for the image carousel
import { PageTitle } from "../components/PageTitle";
import { AchievementCards } from "../components/AchievementCards";
import highlights from "../data/Highlights.json";

export default function Highlights() {
  const highlightTypes = [
    {
      type: "achievements",
      displayName: "Achievements",
    },
    {
      type: "publications",
      displayName: "Publications",
    },
    {
      type: "contributions",
      displayName: "Contributions",
    },
  ];

  const achievementsByYearAndTeam = highlights.reduce((acc, cur) => {
    if (cur.type === "achievements") {
      const year = cur.year || "Other";
      const team = cur.team || "Other";
      if (!acc[year]) acc[year] = {};
      if (!acc[year][team]) acc[year][team] = [];
      acc[year][team].push(cur);
    }
    return acc;
  }, {});

  const sortedAchievementsByYear = Object.keys(achievementsByYearAndTeam)
  .sort((a, b) => Number(b) - Number(a));

  return highlightTypes.map((item, index) => {
    const isLast = index === highlightTypes.length - 1;
    const isAchievements = item.type === "achievements";

    const content = isAchievements ? (
      <Container className="page-container" id={item.type}>
        <Stack gap={3}>
          <PageTitle title={item.displayName}></PageTitle>
          <Container>
            <Stack>
              <Container>
                {sortedAchievementsByYear.map((year) => {
                  const teams = Object.keys(achievementsByYearAndTeam[year]);
                  return (
                    <div key={year}>
                      <h3 className="team-year" style={{marginTop: "10px"}}><b>{year}</b></h3>
                      <hr />
                    {teams.map((team) =>
                      achievementsByYearAndTeam[year][team] &&
                      achievementsByYearAndTeam[year][team].length > 0 ? (
                        <div key={team}>
                          <h4 style={{ marginTop: "20px" }}><b>{team}</b></h4>
                          <AchievementCards achievements={achievementsByYearAndTeam[year][team]} />
                        </div>
                      ) : null
                    )}
                    </div>
                  );
                })}
              </Container>
            </Stack>
          </Container>
        </Stack>
      </Container>
    ) : (
      <Container className="page-container" id={item.type}>
        <Stack gap={3}>
          <PageTitle title={item.displayName} />
          <AchievementCards
            achievements={highlights.filter(
              (highlight) => highlight.type === item.type
            )}
          />
        </Stack>
      </Container>
    );

    return (
      <React.Fragment key={item.type}>
        {content}
        {!isLast && <div className="page-divider" />}
      </React.Fragment>
    );
  });
}
